/**
 * Pareja · «Quién apuntó qué»: las personas con acceso a un presupuesto y la
 * inicial con la que sale cada una junto a lo que apunta.
 */

export type Tripulante = {
  userId: string;
  nombre: string;
  inicial: string;
  esYo: boolean;
};

type Acceso = {
  userId: string;
  userName: string;
  displayName?: string | null;
};

function letras(nombre: string, cuantas: number): string {
  return Array.from(nombre.trim()).slice(0, cuantas).join('').toUpperCase();
}

/**
 * La tripulación (sin el usuario anónimo del servidor). Si dos nombres
 * empiezan igual, llevan dos letras para distinguirse.
 */
export function tripulacion(
  accesos: Acceso[],
  miId: string | null,
): Tripulante[] {
  const personas = accesos
    .filter(a => a.userName !== '')
    .map(a => ({
      userId: a.userId,
      nombre: (a.displayName || a.userName.split('@')[0]).trim(),
      esYo: a.userId === miId,
    }));
  return personas.map(p => {
    const repetida = personas.some(
      o => o.userId !== p.userId && letras(o.nombre, 1) === letras(p.nombre, 1),
    );
    return { ...p, inicial: letras(p.nombre, repetida ? 2 : 1) || '?' };
  });
}

/** Quién apuntó un movimiento, si el presupuesto es de más de una persona. */
export function autorDe(
  tripulantes: Tripulante[],
  autor: string | null | undefined,
): Tripulante | null {
  if (!autor || tripulantes.length < 2) {
    return null;
  }
  return tripulantes.find(t => t.userId === autor) ?? null;
}

/** Días que le quedan a un enlace (al menos 1 mientras siga vigente). */
export function diasHasta(caducaS: number, ahoraMs = Date.now()): number {
  return Math.max(1, Math.ceil((caducaS * 1000 - ahoraMs) / 86_400_000));
}
